/* unplugin-vue-components disabled */import script from "./past-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./past-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./past-dialog.vue?vue&type=style&index=0&id=5d72edfc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d72edfc"]])

export default __exports__